import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/CorporateAttributes/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CorporateAttributesQueries extends VueCqrs
{
	runManageAllPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildManageAllPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runAttributeEditorQueryV1(workspaceId: number, tchProjectId: number, attributeId: number | null)
	{
		const query = q.buildAttributeEditorQueryV1(workspaceId, tchProjectId, attributeId);
		this.$query(query);
	}

	runAttributeByIdQueryV1(workspaceId: number, tchProjectId: number, alternativesListId: number, attributeId: number)
	{
		const query = q.buildAttributeByIdQueryV1(workspaceId, tchProjectId, alternativesListId, attributeId);
		this.$query(query);
	}

	runCalcAttributeScriptTestQueryV1(workspaceId: number, tchProjectId: number, alternativesListId: number, script: string, inputs: { Name: string, Value: number }[])
	{
		const query = q.buildCalcAttributeScriptTestQueryV1(workspaceId, tchProjectId, alternativesListId, script, inputs);
		this.$query(query);
	}
}